/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export enum SystemWorkspaceId {
  Blank = 'blank',
  DefaultPractice = 'defaultPractice',
  DefaultQualifying = 'defaultQualifying',
  DefaultRace = 'defaultRace',
  DefaultRaceIndy = 'defaultRaceIndy',
  DefaultTest = 'defaultTest',
  MobileView = 'mobileView',
  MobileViewIndy = 'mobileViewIndy',
  BlankIndy = 'blankIndy',
  BlankNascar = 'blankNascar',
}

export const systemWorkspaceIdSlug: Record<SystemWorkspaceId, string> = {
  [SystemWorkspaceId.Blank]: 'blank',
  [SystemWorkspaceId.DefaultPractice]: 'default-practice',
  [SystemWorkspaceId.DefaultQualifying]: 'default-qualifying',
  [SystemWorkspaceId.DefaultRace]: 'default-race',
  [SystemWorkspaceId.DefaultRaceIndy]: 'default-race-indy',
  [SystemWorkspaceId.DefaultTest]: 'default-test',
  [SystemWorkspaceId.MobileView]: 'mobile-view',
  [SystemWorkspaceId.MobileViewIndy]: 'mobile-view-indy',
  [SystemWorkspaceId.BlankIndy]: 'blank-indy',
  [SystemWorkspaceId.BlankNascar]: 'blank-nascar',
};
